import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { MVTLayer as DeckMVTLayer } from '@deck.gl/geo-layers';
import findIndexBinary from './utils/find-index-binary';
import { Matrix4 } from '@math.gl/core';
import { COORDINATE_SYSTEM } from '@deck.gl/core';
import { ClipExtension } from '@deck.gl/extensions';
import VectorLayer from './VectorLayer';
var WORLD_SIZE = 512;
var MVTLayer = /*#__PURE__*/function (_DeckMVTLayer) {
  _inherits(MVTLayer, _DeckMVTLayer);
  var _super = _createSuper(MVTLayer);
  function MVTLayer(props) {
    var _this;
    _classCallCheck(this, MVTLayer);
    _this = _super.call(this, props);
    _this.displayTooltip = true;
    return _this;
  }
  _createClass(MVTLayer, [{
    key: "getHighlightedObjectIndex",
    value: function getHighlightedObjectIndex(tile) {
      var _this$state = this.state,
        hoveredFeatureId = _this$state.hoveredFeatureId,
        hoveredFeatureLayerName = _this$state.hoveredFeatureLayerName,
        binary = _this$state.binary;
      var fidColumnName = this.props.fidColumnName;
      var highlightedFeatureId = Number(this.state.higlightedFeature) || this.state.higlightedFeature;
      var data = tile.content;
      var isHighlighted = isFeatureIdDefined(highlightedFeatureId);
      var isFeatureIdPresent = isFeatureIdDefined(hoveredFeatureId) || isHighlighted;
      if (!isFeatureIdPresent) {
        return -1;
      }
      var featureIdToHighlight = isHighlighted ? highlightedFeatureId : hoveredFeatureId;

      // Iterable data
      if (Array.isArray(data)) {
        return data.findIndex(function (feature) {
          var isMatchingId = getFeatureUniqueId(feature, fidColumnName) === featureIdToHighlight;
          var isMatchingLayer = isHighlighted || getFeatureLayerName(feature) === hoveredFeatureLayerName;
          return isMatchingId && isMatchingLayer;
        });

        // Non-iterable data
      } else if (data && binary) {
        // Get the feature index of the selected item to highlight
        return findIndexBinary(data, fidColumnName, featureIdToHighlight, isHighlighted ? '' : hoveredFeatureLayerName);
      }
      return -1;
    }
  }, {
    key: "onClick",
    value: function onClick(obj, evt) {
      obj.tile.layers[0].onClick(obj, evt);
      return true;
    }

    /**
     * Call on feature hover
     * @param data {Object}
     */
    // FIXME
    // onHover(obj, evt) {
    // obj.tile.layers[0].onClick(obj, evt);
    // return true;
    // }
  }, {
    key: "renderSubLayers",
    value: function renderSubLayers(props) {
      var _props$tile$index = props.tile.index,
        x = _props$tile$index.x,
        y = _props$tile$index.y,
        z = _props$tile$index.z;
      var worldScale = Math.pow(2, z);
      var xScale = WORLD_SIZE / worldScale;
      var yScale = -xScale;
      var xOffset = WORLD_SIZE * x / worldScale;
      var yOffset = WORLD_SIZE * (1 - y / worldScale);
      var modelMatrix = new Matrix4().scale([xScale, yScale, 1]);
      props.autoHighlight = false;
      if (!this.context.viewport.resolution) {
        props.modelMatrix = modelMatrix;
        props.coordinateOrigin = [xOffset, yOffset, 0];
        props.coordinateSystem = COORDINATE_SYSTEM.CARTESIAN;
        props.extensions = [].concat(_toConsumableArray(props.extensions || []), [new ClipExtension()]);
      }
      return [new VectorLayer(_objectSpread(_objectSpread({}, props), {}, {
        key: props.id,
        options: _objectSpread(_objectSpread({}, props.options), {}, {
          features: props.data
        })
      }))];
    }
  }]);
  return MVTLayer;
}(DeckMVTLayer);
function getFeatureUniqueId(feature, uniqueIdProperty) {
  if (uniqueIdProperty) {
    return feature.properties[uniqueIdProperty];
  }
  if ('id' in feature) {
    return feature.id;
  }
  return -1;
}
function getFeatureLayerName(feature) {
  var _feature$properties;
  return ((_feature$properties = feature.properties) === null || _feature$properties === void 0 ? void 0 : _feature$properties.layerName) || null;
}
function isFeatureIdDefined(value) {
  return value !== undefined && value !== null && value !== '';
}
export default MVTLayer;